<template>
  <Breadcrumb
    v-if="deviceType === 'PC'"
    :category-name="categoryName"
  />
  <Header v-else />
  <main
    class="featured"
  >
    <H5TagFilter v-if="deviceType === 'MOBILE'" />
    <TagFilter v-else />
    <Product
      class="featured__content"
      :loading="loading"
      :product-list="list"
      @load="onLoad"
      @item-click="onItemClick"
    />
  </main>
</template>

<script setup>
import Header from './components/NewHeader/index.vue'
import TagFilter from './components/TagFilter/index.vue'
import H5TagFilter from './components/H5TagFilter/index.vue'
import Breadcrumb from './components/Breadcrumb/index.vue'
import { useProductList } from './hooks/useProductList'
import { Product } from '@/components/NewProduct'
import { useDevice } from '@/hooks/useDevice'
import { buriedPointUtil, metaPixelTrack, openURLWithChannelQuery } from '@/utils/utils'

const route = useRoute()
const { deviceType } = useDevice()

const categoryName = computed(() => route.query.categoryName)

const { loading, list, onLoad } = useProductList()

onBeforeMount(() => {
  /**
   * 业务埋点：网页Featured页面浏览事件
   */
  buriedPointUtil({ eventId: deviceType.value === 'MOBILE' ? 'HFC101' : 'PFC101' })
})

const onItemClick = (item) => {
  /**
   * Meta Pixel 埋点：网页Featured页面内点击商品前往查看商品详情
   */
  metaPixelTrack('PFP201', 'ViewContent', {
    content_ids: [item.offerId],
    content_type: 'product',
    currency: '$',
    value: 0.2
  })
  /**
   * 业务埋点：网页Featured页面内点击商品前往查看商品详情
   */
  buriedPointUtil({ eventId: deviceType.value === 'MOBILE' ? 'HFP201' : 'PFP201', offerId: item.offerId })

  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}&adding=${btoa(item.addingCount)}&skuId=${item.skuId}&from=${route.name}`)
}
</script>

<style lang="less" scoped>
.featured {
   @media (min-width: 1024px) {
      margin: 0 auto;
      max-width: 1200px;
   }

  &__content {
    padding: 16px;

    @media (min-width: 1024px) {
      padding: 16px 0;
    }
  }
}
</style>
